import { render, staticRenderFns } from "./partnersForm.vue?vue&type=template&id=2a49228e&"
import script from "./partnersForm.vue?vue&type=script&lang=js&"
export * from "./partnersForm.vue?vue&type=script&lang=js&"
import style0 from "./partnersForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports